export default __webpack_public_path__ + "static/media/arm_swing_a.dc00dc03.png";